import { render, staticRenderFns } from "./MerchRelease.vue?vue&type=template&id=6f3239fa"
import script from "./MerchRelease.vue?vue&type=script&lang=js"
export * from "./MerchRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports